
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#A4A8C0","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"1.5","d":"M17.89 6.724v10.887c0 1.353-1.121 2.458-2.506 2.458H9.616c-1.385 0-2.506-1.092-2.506-2.458V6.724m-2.166-.049h15.111m-9.469 9.185v-4.766m3.828 4.766v-4.766m-3.249-4.531l-.013-1.688c0-.522.429-.944.97-.944h.755c.53 0 .97.422.97.944l.013 1.688"}})])
          )
        }
      }
    